export default "__VITE_ASSET__OfK_Zits__"